<template>
  <div
    @click="change($event, itemId, option, item)"
    :class="`d-flex     align-items-center  my-1 p-0   display-style-col`"
    :style="{ width: 100 / col_number + `%` }"
  >
    <input
      v-model="option.selected"
      v-if="includes(option_show_kind, [2, 4, 7])"
      class="my-2"
      type="checkbox"
    />
    <span class="px-1" v-if="option_show_kind == 4">
      {{ this.$vnode.key + 1 }})</span
    >
    <input
      :checked="option.selected"
      v-if="includes(option_show_kind, [1, 3, 6])"
      :value="option.option_description"
      class="my-2"
      type="radio"
      :id="itemId + `_` + option.id"
      :name="`radio-${itemId + `_` + option.id}`"
    />
    <span
      v-if="includes(option_show_kind, [3, 8, 10])"
      class="d-flex align-items-center px-1"
      >{{ this.$vnode.key + 1 }})
    </span>

    <div
      :class="`${
        option.selected ? `templateActive` : `templateNotActive`
      } template d-flex align-items-center`"
    >
      <div
        :class="`d-flex align-items-center ${
          display_style == 3 ? `textOrientation` : ``
        }`"
      >
        <span
          v-if="!option.is_image"
          class="p-1 text-question"
          v-html="createPureDom(option.option_description)"
        />
        <ImageBox
          v-if="showImage"
          :downloadCode="option.download_code"
          imageClass="width-50 border-radius-4 bg-white"
          :defaultImage="defaultImage"
          loadingClass="right-0 top-0 width-50 border-radius-4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { includes } from "ramda";
import { createPureDom, generateConfig } from "@/shared/utils";
import { ImageBox } from "@/components/re-design";

export default {
  name: "option-checked",
  components: { ImageBox },
  props: {
    itemId: {
      type: [String, Number],
      default: "",
    },
    option: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
    option_show_kind: {
      type: [String, Number],
      default: "",
    },
    display_style: {
      type: [String, Number],
      default: "",
    },
    col_number: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    showImage() {
      return (
        this.option.is_image && includes(this.option_show_kind, [5, 6, 7, 8])
      );
    },
    defaultImage() {
      return generateConfig([
        "images",
        "shared",
        "redesign",
        "empty",
        "noUser",
      ]);
    },
  },
  methods: {
    createPureDom,
    includes,
    change(event, itemId, option, item) {
      this.$emit("optionChecked", item, option, itemId);
    },
  },
};
</script>
<style lang="scss">
.templateNotActive {
  height: 100%;
  width: 100%;
  border-radius: 5px;
  padding: 0 5px;
  margin: 0 5px;
  border: 2px solid lightgray;
  background-color: lightgray;
}

.templateActive {
  width: 100%;
  border: 2px solid #243c44 !important;
  background-color: #243c44 !important;
  color: white !important;
  margin: 0 5px;
  border-radius: 5px;
  padding: 0 5px;
  height: 100%;
}
.templateActive * {
  background-color: #243c44 !important;
  color: white !important;
}

.template {
  cursor: pointer;
}

.template:hover {
  border: 2px solid #9e9e9e;
}
.text-question {
  p {
    margin: 0;
    padding: 0;
  }
}
.textOrientation {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

@media (max-width: 800px) {
  .display-style-col {
    width: 50% !important;
  }
}

@media (max-width: 600px) {
  .display-style-col {
    width: 100% !important;
  }
}
</style>
